<template>
    <!-- ОТРИСОВКА БЛОКОВ -->
    <div class="anime-cards">
        <div v-for="anime, i in anime_list" :key="i" class="anime-card">
            <router-link :to="'/' + anime.shikimori_id" target="_blank">
              <div class="img-hidden">
                  <img style="width:100%" :src="anime.material_data ? (anime.material_data.poster_url ? anime.material_data.poster_url.replace('.me/', '.one/') : '') : ''" alt="">
                  <span >
                      <img src="@/assets/icons/shikimori_icon.svg">  {{ anime.material_data ? anime.material_data.shikimori_rating  : "0.0" }}
                  </span>
              </div>
            </router-link>
            <div class="forMobile">
                <router-link :to="'/' + anime.shikimori_id" :title="anime.title" target="_blank">
                    <div class="three-dots h2-monts" >
                        {{ anime.title }}
                    </div>
                </router-link>
                <div class="onlyForMobile">
                    <span :class="status_paint(anime)">{{ getRuStatus(anime.material_data ? anime.material_data.anime_status || '' : '') }}</span>
                    <br>
                    <p style="margin: 5px 0">{{ getRuKind(anime.material_data ? anime.material_data.anime_kind : '') }}</p>
                </div>
            </div>
            
            <router-view></router-view>
        </div>
    <!-- ОТРИСОВКА БЛОКОВ END-->
    </div>
</template>

<script>

export default{
    props:{
        anime_list:{
            required: true
        }
    },
    methods:{
        //CLEAN FUNCTION
        //Получаем статус тайтла на английском, а возвращаем на русском
        //@param {string} берет строку на англйском
        //@return {string} возвращает новую строку на русском
        getRuStatus: function(status){
            switch (status) {
                case 'released':
                return 'Вышел';
                case 'ongoing':
                return 'Выходит';
                case 'anons':
                return 'Анонс';
                default:
                return status;
            }
        },
        //CLEAN FUNCTION
        //Описание: Получаем тип тайтла на английском, а возвращаем на русском
        //@param {string} берет строку на англйском
        //@return {string} возвращает новую строку на русском
        getRuKind: function(kind){
            switch (kind) {
                case 'tv':
                  return 'Сериал';
                case 'movie':
                  return 'Фильм';
                case 'ova':
                  return 'OVA';
                case 'ona':
                  return 'ONA';
                case 'special':
                  return 'Спэшл';
                case 'music':
                  return 'Музыка';
                default:
                  return kind;
            }
        },
        //CLEAN FUNCTION
        //Описание: Получаем статус тайтла на английском, а возвращаем его цвет для отображения в span'е
        //@param {string} берет строку на англйском
        //@return {string} возвращает новую строку на русском
        status_paint(anime){
          if(anime.material_data){
            if(anime.material_data.anime_status === 'ongoing'){
              return 'blue';
            }else if(anime.material_data.anime_status === 'anons'){
              return 'red';
            }else{
              return 'green'
            }
          }else{
            return '';
          }
        }
    }
    
}

</script>

<style lang="scss" scoped>
.anime-cards {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* margin: 0 150px; */
}
.h2-monts{
  font-size: 20px;
  font-family: 'Montserrat', sans-serif;
}
.anime-card {
  margin: 1rem;
  flex: 1 0 200px;
  display: flex;
  flex-direction: column;
  align-items: center;

/*  opacity: 0.1;*/ 
}


.main-page .img-hidden span{
  position: absolute;
  background: #3e3e3e; 
  border-radius: 5px;
  padding: 2px 8px;
  bottom: 10px;
  left: 10px;
/*  right: 10px;*/
}

.img-hidden img{
  width: 14px; 
  transform:translateY(1px);
  transition: .5s;
}

.img-hidden{
  transition: .3s scale, 3s;
}

.img-hidden:hover{
  box-shadow: 0 0 63px 35px #007aff3d;
}

.img-hidden img:hover{
  transform:scale(1.3);
}

.img-hidden:hover{

  transform:scale(1.1);
}

.forMobile .three-dots{
  margin-top: 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 204px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
}

.img-hidden{
  position: relative;
  width: 225px;
  height: 305px;
  border-radius: 8px;
  overflow: hidden;
}

.onlyForMobile{
  display: none;
}

@media only screen and (max-width: 600px) {

  .anime-card{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin: 15px 20px;
    opacity: 1;
  }

  .img-hidden {
    width: 120px;
    height: 155px;
    border-radius: 10px;
    /*opacity: 0.1; */
    background-size: cover;
  }

  .main-page .img-hidden span{
    bottom: 4px;
    left: 2px;
    transform: scale(0.8);
  }

  .forMobile .three-dots{
    margin: 0 0 5px 20px;
    text-align: left;
  }

  .onlyForMobile{
    display: block;
    margin: 0 0 0 20px;
    font-weight: bold;
    color: grey;
  }

  .onlyForMobile img{
    width: 22px;
    transform: translateY(4px);
  }

  .onlyForMobile span{
    margin-right: 10px;
    color: white;
  }

  .onlyForMobile .blue{
    background-color: #0d6efd;
    padding: 3px 5px;
    border-radius: 4px;
  }



  .onlyForMobile .red{
    background-color: red;
    padding: 3px 5px;
    border-radius: 4px;
  }

  .onlyForMobile .green{
    background-color: green;
    padding: 3px 5px;
    border-radius: 4px;
  }

  .img-hidden span{
    bottom: 4px;
    left: 2px;
    transform: scale(0.8);
  }
  
}
</style>
